import { UrlBase } from '@/config/base.config'
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'

export class AuthService {
    baseUrl: string
    axiosObj: AxiosInstance

    constructor () {
      this.baseUrl = UrlBase
      this.axiosObj = axios.create({
        baseURL: UrlBase,
        timeout: 10000
      })
    }

    async authEmail (email: string, password: string) {
      try {
        const user = await this.axiosObj.post('auth/login', { username: email, password: password })
        return user.data.accessToken
      } catch (e) {
        throw new Error(e)
      }
    }

    async getProfile (accessToken: string) {
      try {
        const config: AxiosRequestConfig = {
          headers: { Authorization: `Bearer ${accessToken}` }
        }
        const profile = await this.axiosObj.get('profile', config)
        return profile.data
      } catch (e) {
        throw new Error(e)
      }
    }
}
